export default __webpack_public_path__ + "static/media/onboardingAsideMb.587f305d.png";